// pfs-stack.ts — vertikaler gap-Container (PFS-652 Spacing-System).
//
// Generisches Layout-Primitive: stapelt seine Kinder mit einem gap aus der
// Spacing-Skala. KEIN margin. data-gap wählt den Skalen-Schritt (Default: field).
//
//   <pfs-stack data-gap="section"> … </pfs-stack>
//
// Alle Abstände = gap [[feedback_gap_only_spacing]]; Werte via --pfs-space-*
// überschreibbar (Default = Plattform-Wert).
import { defineComponent } from "../../composition/define-component.js";
import { withShadow } from "../../composition/with-shadow.js";

const STYLES = `
:host { display: flex; flex-direction: column; gap: var(--pfs-space-field, 0.75rem); }
:host([data-gap="section"]) { gap: var(--pfs-space-section, 1rem); }
:host([data-gap="field"]) { gap: var(--pfs-space-field, 0.75rem); }
:host([data-gap="label"]) { gap: var(--pfs-space-label, 0.5rem); }
:host([data-gap="title"]) { gap: var(--pfs-space-title, 0.25rem); }
`;

defineComponent({
  tagName: "pfs-stack",
  eager: true, // synchron von Cut-App-WCs konsumiert
  mixins: [withShadow()],
  render(_host, ctx) {
    const root = ctx.shadowRoot;
    if (!root) return;
    const style = document.createElement("style");
    style.textContent = STYLES;
    root.append(style, document.createElement("slot"));
  },
});
